import { literal, string, struct } from 'io-ts/lib/Decoder';

import { Opening } from '../frame/Opening';

/**
 * Sent when an opening is updated.
 * Server will recompute the frame geometry after update.
 */
export const OpeningUpdated = struct({
	type: literal('opening-updated'),
	frameId: string,
	opening: Opening,
});
